import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { MediaAssetItem } from '../models';
let SyncMediaAssetSubtitlesResponse = /*#__PURE__*/(() => {
  let SyncMediaAssetSubtitlesResponse = class SyncMediaAssetSubtitlesResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", MediaAssetItem)], SyncMediaAssetSubtitlesResponse.prototype, "updatedAsset", void 0);
  SyncMediaAssetSubtitlesResponse = __decorate([ModelId("SyncMediaAssetSubtitlesResponse") // auto-generated by sync-model-ids
  ], SyncMediaAssetSubtitlesResponse);
  return SyncMediaAssetSubtitlesResponse;
})();
export { SyncMediaAssetSubtitlesResponse };
let SyncMediaAssetSubtitlesRequest = /*#__PURE__*/(() => {
  let SyncMediaAssetSubtitlesRequest = class SyncMediaAssetSubtitlesRequest extends Model {
    static {
      this.Response = SyncMediaAssetSubtitlesResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], SyncMediaAssetSubtitlesRequest.prototype, "assetId", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], SyncMediaAssetSubtitlesRequest.prototype, "subtitleId", void 0);
  SyncMediaAssetSubtitlesRequest = __decorate([AppRequest('media', 'assets/sync-subtitles', {
    httpMethod: AppRequestMethod.POST,
    simpleAbilityCheck: 'ADMINISTRATOR'
  }), ModelId("SyncMediaAssetSubtitlesRequest") // auto-generated by sync-model-ids
  ], SyncMediaAssetSubtitlesRequest);
  return SyncMediaAssetSubtitlesRequest;
})();
export { SyncMediaAssetSubtitlesRequest };